import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { image, SanityImage } from './image';
import { link, SanityLink } from './link';
import { richText } from './richText';
import { SanityVideoLoop, videoLoop } from './videoLoop';

export type SanityFullWidthMediaSource = {
  mediaType: 'youtube' | 'videoLoop' | 'image';
  thumbnailImage?: SanityImage | null;
  videoUrl?: string | null;
  videoLoop?: SanityVideoLoop | null;
  image?: SanityImage | null;
};

export const SanityFullWidthVideo = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('fullWidthVideo'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  eyebrow: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  description: SanityBasicText.optional().nullable(),
  cta: SanityLink.optional().nullable(),
  mediaType: z.enum(['youtube', 'videoLoop', 'image']),
  thumbnailImage: SanityImage.optional().nullable(),
  videoUrl: z.string().optional().nullable(),
  videoLoop: SanityVideoLoop.optional().nullable(),
  image: SanityImage.optional().nullable(),
  hideMediaOnMobile: z.boolean().optional().nullable(),
  mobileMedia: z
    .object({
      mediaType: z
        .enum(['youtube', 'videoLoop', 'image'])
        .optional()
        .nullable(),
      thumbnailImage: SanityImage.optional().nullable(),
      videoUrl: z.string().optional().nullable(),
      videoLoop: SanityVideoLoop.optional().nullable(),
      image: SanityImage.optional().nullable(),
    })
    .optional()
    .nullable(),
});
export type SanityFullWidthVideo = z.infer<typeof SanityFullWidthVideo>;

const mediaSource = groq`{
  mediaType,
  thumbnailImage ${image},
  videoUrl,
  videoLoop ${videoLoop},
  image ${image},
}`;

export const fullWidthVideo = groq`{
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "charcoal")),
  eyebrow,
  title,
  description[] ${richText},
  cta[0] ${link},
  "mediaType": coalesce(mediaType, "youtube"),
  thumbnailImage ${image},
  videoUrl,
  videoLoop ${videoLoop},
  image ${image},
  "hideMediaOnMobile": coalesce(hideMediaOnMobile, false),
  mobileMedia ${mediaSource},
}`;
